export const CREATE_PRO_FORMA_STEPS = {
    STEP_1: 1,
};

export const MOCK_SCENARIO_OPTIONS = [
    {
        value: 1,
        label: 'Scenario 1',
    },
    {
        value: 2,
        label: 'Scenario 2',
    },
];
